import { render, staticRenderFns } from "./fanZone.vue?vue&type=template&id=a8724bb8&scoped=true"
import script from "./fanZone.vue?vue&type=script&lang=js"
export * from "./fanZone.vue?vue&type=script&lang=js"
import style0 from "./fanZone.vue?vue&type=style&index=0&id=a8724bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8724bb8",
  null
  
)

export default component.exports